import _ from 'lodash';

export function pluralize(count: number, word: string, plural: string) {
  return `${count.toLocaleString()} ${count === 1 ? word : plural}`;
}

export function calculateNormalizedPercentage<T>({
  targetValue,
  valueCounts,
  isLastValue,
  denominator,
}: {
  targetValue: T;
  valueCounts: Array<[T, number]>;
  isLastValue: boolean;
  denominator: number;
}): {count: number; percentage: number} {
  if (denominator === 0) {
    return {count: 0, percentage: 0};
  }

  const count =
    _.find(valueCounts, ([value]) => value === targetValue)?.[1] ?? 0;

  if (!isLastValue) {
    return {
      count,
      percentage: Math.round((count / denominator) * 100),
    };
  }

  // For the last value, adjust to ensure total equals 100
  let percentage = 100;
  for (const [value, count] of valueCounts) {
    if (value === targetValue) {
      continue;
    }

    // Ensure we don't subtract more than the remaining percentage
    percentage = Math.max(
      0,
      percentage - Math.round((count / denominator) * 100)
    );
  }

  return {
    count,
    percentage,
  };
}

export function maskString({
  str,
  visibleLength,
  maskLength,
}: {
  str: string;
  visibleLength: number;
  maskLength?: number;
}) {
  if (visibleLength > str.length) {
    return str;
  }

  const visibleStr = str.slice(-visibleLength);
  return '*'.repeat(maskLength ?? str.length - visibleLength) + visibleStr;
}
